import React, { useState, useEffect, useRef } from "react";
import { Col, Grid } from "antd";
import { useTranslation } from "react-i18next";

import { CloseIcon, DownloadIcon, NoDataIcon } from "icons";
import { generateImg, handleCheckValue, localStorageHelper } from "utils";

import {
  BoxItem4Chart,
  WrapperCloseIcon,
  BoxHeader,
  BoxTitle,
  LightDivider4Chart,
  BoxContent4Chart,
  WrapperLegend,
  RedRectangle,
  YellowRectangle,
  BlueRectangle,
  SilverRectangle,
  GreenRectangle,
  WrapperDisorderStatistical,
  TriangleUp,
  TriangleDown,
  DisorderStatisticalHeader,
  BoxItem4DisorderChart,
  ContainerChart,
  WrapperChart,
  WrapperDisorderContent,
} from "../Dashboard.style";
import PieChart from "./PieChart";
import { IChart } from "../BodyTemperatureResult";

const DisorderStatistical = ({ data }: any) => {
  const imgRef = useRef<any>();
  const currentLanguage = localStorageHelper.getItem("i18nextLng");

  return (
    <Col xs={24} md={24} xl={12} ref={imgRef}>
      <WrapperChart>
        <ContainerChart>
          <BoxItem4DisorderChart>
            <DisorderStatisticalHeader>
              <div></div>
              <WrapperDisorderContent>
                <div></div>
                <BoxTitle>
                  {currentLanguage === "vi" ? "Tăng trưởng" : "前月比"}
                </BoxTitle>
                <BoxTitle>
                  {currentLanguage === "vi" ? "Tỷ lệ trả lời" : "回答率"}
                </BoxTitle>
              </WrapperDisorderContent>
              {/* <DownloadIcon
            fill="#3B3B3B"
            style={{ marginTop: 4, cursor: "pointer" }}
            onClick={(event: any) => {
              if (!event.detail || event.detail == 1) {
                generateImg("physical-disorder", imgRef.current);
              }
            }}
          /> */}
            </DisorderStatisticalHeader>
            <LightDivider4Chart />
            <BoxContent4Chart>
              <WrapperDisorderStatistical>
                {data.length > 0 &&
                  data.map((item: any, idx: number) => {
                    return (
                      <div key={idx}>
                        <div>{item.affliation}</div>
                        <WrapperDisorderContent>
                          <div style={{ width: 18 }}>
                            <TriangleUp />
                          </div>
                          <div>{item.month_to_month_basis}</div>
                          <div>{item.response_rate}%</div>
                        </WrapperDisorderContent>
                      </div>
                    );
                  })}
              </WrapperDisorderStatistical>
              {/* <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 17,
              }}
            >
              <NoDataIcon />
            </div>
          )} */}
            </BoxContent4Chart>
          </BoxItem4DisorderChart>
        </ContainerChart>
      </WrapperChart>
    </Col>
  );
};

export default DisorderStatistical;
